<p-dialog [modal]="true"
  [blockScroll]="true"
  [(visible)]="visible"
  [title]="overlayTitle"
  [header]="overlayTitle">
  <form [formGroup]="form" (ngSubmit)="saveConversationRecord()">
    <his-plam>
      <input #content
        type="text"
        formControlName="title"
        [hisDdKey]="uiText.COMMUNICATION_LOG_ENTRY_TITLE"
        required
        hisTrimInput
        class="inputWidth100">
    </his-plam>
    <his-plam>
      <textarea #content
        type="text"
        formControlName="text"
        [hisDdKey]="uiText.COMMUNICATION_LOG_ENTRY_TEXT"
        [rows]="10"
        class="textareaWidth100"
        hisTrimInput>
      </textarea>
    </his-plam>
    @if (availableDomains?.length > 1) {
      <his-plam>
        <his-multiselect #content
          required
          formControlName="domains"
          [ddKey]="uiText.COMMUNICATION_LOG_ENTRY_DOMAINS"
          [hisDdKey]="uiText.COMMUNICATION_LOG_ENTRY_DOMAINS"
          [customOptionsMethod]="customDomainOptions.bind(this)"
          [removeSelectedOptionsFromDropdown]="true">
        </his-multiselect>
      </his-plam>
    }
    <button type="submit">{{ uiText.SAVE | hisUi }}</button>
    <button type="button" (click)="cancel()">{{ uiText.CANCEL | hisUi }}</button>
  </form>
</p-dialog>